import Notice from './index';

export default { path: '/home/notice', component: Notice };
